/* globals Image */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.designGallery = (function () {
    function updateImageSizes () {
      const images = $('.galleryImage')
      images.each(function (index, el) {
        // console.log('updating height of', el);
        const $el = $(el)
        const w = $el.width()
        // $el.width(w); // set to exact value
        $el.height(w)
      })
      // eslint-disable-next-line no-unused-vars
      const filterizd = $('.filtr-container').filterizr({
        // options object
        layout: 'packed'
      })
    }

    const initialize = function () {
      const $grid = $('#design-gallery')
      if ($grid.length === 0) {
        return
      }

      updateImageSizes()
      // $(window).on('resize', updateImageSizes);

      const gallery = eah.gallery || null

      $('.design-gallery a').on('click', function (e) {
        e.preventDefault()
      })

      // const $previousDesignGalleryItems = []
      $('.design-gallery__container .js-controlLink').on('click', function (e) {
        e.preventDefault()
        const $this = $(this)
        const desiredLook = $(this).attr('data-img-filter-button')

        // console.log('desired look: ', desiredLook);

        $this.closest('.wrap').find('.grid').removeAttr('id').attr('id', desiredLook)
        $this.parent().addClass('is-selected').siblings().removeClass('is-selected')
        // $this.parent().data('active', true).siblings().data('active', false);
        $('.design-gallery .grid').attr('data-active-section', desiredLook)

        // var $visibleDesignGalleryItems = $('.galleryImage').filter(function () {
        //   console.log('comparing', $(this).data('section'), desiredLook);
        //   return $(this).data('section') == desiredLook || desiredLook == 'all'
        // }).data('active', true).addClass('active').fadeIn(600);
        // console.log('now visible', $visibleDesignGalleryItems);

        // updateImages(gallery);
      })

      // go ahead and preload all images for this gallery
      if (gallery) {
        for (let key in gallery) {
          if (gallery.hasOwnProperty(key)) {
            let img = new Image()
            img.src = gallery[key].image_url
          }
        }
      }

      // updateImages(gallery);
    }

    // eslint-disable-next-line no-unused-vars
    function updateImages (gallery) {
      const currentGallery = $('.grid').attr('id')
      const pinterestLink = 'https://www.pinterest.com/pin/create/button/?url={url}&media={media}&description={description}'

      // allow all gallery images to be grouped together in lightbox
      $('.grid').find('a.imageLink').attr('rel', currentGallery)

      // dynamically alter the content based on which filter you are on
      $.each($('.grid .bgImage'), function () {
        const $this = $(this)
        const $parent = $this.parents('.galleryImage')
        const index = $parent.index()
        const $link = $this.parent('a')
        const $caption = $parent.find('.description')
        const $download = $parent.find('a.download')
        const $pinterest = $parent.find('.shareOnPinterest > a') // this is because Pinterest API removes the .pinterest class
        const galleryInfo = gallery[currentGallery + '-' + index]
        const theUrl = encodeURIComponent(window.location.href)
        const theMedia = encodeURIComponent(galleryInfo.image_url)
        const theDescription = encodeURIComponent(galleryInfo.caption).replace(/[!'()]/g, escape).replace(/\*/g, '%2A')

        $pinterest.attr('data-url', theUrl)
        $pinterest.attr('data-media', theMedia)
        $pinterest.attr('data-description', theDescription)

        let pinterest = pinterestLink.replace('{url}', theUrl)
        pinterest = pinterest.replace('{media}', theMedia)
        pinterest = pinterest.replace('{description}', theDescription)

        // update everything with above data
        $link.attr('href', galleryInfo.image_url)
        $download.attr('href', theMedia)
        $caption.html(galleryInfo.caption)
        $pinterest.attr('href', pinterest)
        $pinterest.attr('data-pin-shape', 'round')
      })

      eah.pinterest.reload() // have to reload the pinterest JS
      if (typeof window.parsePinBtns === 'function') {
        window.parsePinBtns() // now have pinterest reload the buttons
      }
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.designGallery.initialize()
  })
}(jQuery, window))
